<div style="display: flex;align-items: stretch;">
  <p-select [options]="data" [(ngModel)]="value" [disabled]="disabled" dataKey="kod" optionLabel="popis" [inputId]="inputId" [ngClass]="headerStyle?'header-style':'body-style'"
            placeholder=" " [virtualScroll]="virtualScroll" [virtualScrollItemSize]="38" [filter]="filter" filterBy="popis"></p-select>
</div>
